module.exports = __webpack_public_path__ + "static/media/project-based-programming.svg.060c5f67.svg";